/**
 * AWS Amplify configuration for activQMS
 *
 * This file contains the Amplify configuration for connecting
 * to AWS services including Cognito and AppSync.
 */

// Environment variables (these would be injected at build time)
const config = {
  aws_project_region: import.meta.env.VITE_AWS_REGION || "us-east-1",
  aws_cognito_region: import.meta.env.VITE_AWS_REGION || "us-east-1",
  aws_user_pools_id: import.meta.env.VITE_USER_POOL_ID || "us-east-1_11PYQetkh",
  aws_user_pools_web_client_id:
    import.meta.env.VITE_USER_POOL_CLIENT_ID || "olju6q3pv9so8rqlj9peduj6e",
  aws_cognito_identity_pool_id: import.meta.env.VITE_IDENTITY_POOL_ID || "",
  aws_appsync_graphqlEndpoint:
    import.meta.env.VITE_GRAPHQL_URL ||
    "https://7ewikwtx2reg7jxq4gfehyxr4u.appsync-api.us-east-1.amazonaws.com/graphql",
  aws_appsync_region: import.meta.env.VITE_AWS_REGION || "us-east-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_appsync_apiKey: import.meta.env.VITE_APPSYNC_API_KEY || "",
};

// Validate configuration before exporting
if (!config.aws_user_pools_id || !config.aws_user_pools_web_client_id) {
  throw new Error(`Missing required Amplify configuration:
    userPoolId: ${config.aws_user_pools_id ? "✓" : "✗"}
    userPoolClientId: ${config.aws_user_pools_web_client_id ? "✓" : "✗"}
  `);
}

export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: config.aws_user_pools_id,
      userPoolClientId: config.aws_user_pools_web_client_id,
      region: config.aws_cognito_region,
    },
  },
};

// Debug logging in development
if (import.meta.env.VITE_STAGE === "dev" || import.meta.env.DEV) {
  console.log("All import.meta.env:", import.meta.env);
  console.log("Environment Variables:", {
    VITE_USER_POOL_ID: import.meta.env.VITE_USER_POOL_ID,
    VITE_USER_POOL_CLIENT_ID: import.meta.env.VITE_USER_POOL_CLIENT_ID,
    VITE_AWS_REGION: import.meta.env.VITE_AWS_REGION,
    VITE_GRAPHQL_URL: import.meta.env.VITE_GRAPHQL_URL,
  });

  console.log("Amplify Config:", {
    userPoolId: config.aws_user_pools_id,
    userPoolClientId: config.aws_user_pools_web_client_id,
    region: config.aws_cognito_region,
    graphqlEndpoint: config.aws_appsync_graphqlEndpoint,
  });

  // Validate required configuration
  if (!config.aws_user_pools_id || !config.aws_user_pools_web_client_id) {
    console.error("Missing required Amplify configuration:", {
      userPoolId: !!config.aws_user_pools_id,
      userPoolClientId: !!config.aws_user_pools_web_client_id,
      graphqlUrl: !!config.aws_appsync_graphqlEndpoint,
    });
  }
}
